import React from "react";

import { Row, Col, Form } from "react-bootstrap";

import DatePicker from "./date-picker";

import { format as formatDate } from "../../../utils/date";
import { deepEqual } from "../../../utils/object";

class DatePickerEx extends React.Component {
    /**
     *
     */
    constructor(props) {
        super(props);
        this.state = {
            configuration: { ...props.meta },
            data: props.data ?? props.meta?.default,
            label: props.label,
            locked: Boolean(props.locked)
        }
    }
    
    getData = () => {
        return this.state.data;
    }
    

    componentDidUpdate(oldProps) {
        // Update state when props.data changes
        if (oldProps.data === this.props.data) return;
        const newData = this.props.data ?? this.props.meta?.default;
        if (deepEqual(this.state.data, newData)) return;

        // Just sync local state – no callback, no props.onChange here
        this.setState({
            data: newData
        });
    }

    onChange = (date) => {
        if (this.state.data === date) return;

        this.setState({
            data: date
        }, () => {
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }

    
    render() {
        return (
            
            <>
                <Row>
                    <Col>
                        <div className="mb-3 top-label">
                            {(this.state.locked) ?
                                <Form.Control type="text" name={this.props.element} value={formatDate(this.state.data) || ""} readOnly={true} />
                                :
                                <DatePicker className="form-control" selected={this.state.data} onChange={this.onChange} placeholder="" name={this.props.element} />
                            }
                            <Form.Label>{this.state.label}</Form.Label>
                        </div>
                    </Col>
                </Row>
            </>
        )
    }
}

export default DatePickerEx;